export const VV_CHAT_WIDTH = 256;
export const VV_CHAT_MID_WIDTH = 180;
export const VV_EDITOR_HEIGHT = 575;
export const VV_EDITOR_WIDTH = 232;

export const deviceKinds = ['audioinput', 'videoinput', 'audiooutput'] as const;
